module.exports = __webpack_public_path__ + "img/slide-4.3f3949f6.webp";